module.exports = __webpack_public_path__ + "static/media/MaterialIcons.8ef52a15.ttf";